export function getContentDispositionFileName(
  contentDispositionHeader: string | null
): string | null {
  if (!contentDispositionHeader || contentDispositionHeader.trim() === '') {
    return null
  }

  const matches = contentDispositionHeader.match(/.(?:filename=)(.*)/)
  if (!matches || matches.length < 2) {
    return null
  }

  return matches[1]
}
